import { useEffect, useState } from 'react';
import { getDataSetTreeAPI } from '../common/services';

/**
 * Loads a data-set's values tree. Refetches when a new version is uploaded.
 *
 * @param {object} dataSet - { id, version } from the data-sets list
 */
const useDataSetTree = ({ id, version }) => {
    const [tree, setTree] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isCurrent = true;
        setIsLoading(true);
        getDataSetTreeAPI(id)
            .then(({ data }) => isCurrent && setTree(data?.items || []))
            .catch((error) => console.error('Error fetching data-set tree', error))
            .finally(() => isCurrent && setIsLoading(false));
        return () => {
            isCurrent = false;
        };
    }, [id, version]);

    return { tree, isLoading };
};

export default useDataSetTree;
